import type { DeliveryListParams } from '../api/webhooks-api';

/** Store-scoped keys: switching stores never shares cache. */
export const webhookKeys = {
  all: (storeId: string) => ['stores', storeId, 'webhooks'] as const,
  events: (storeId: string) => [...webhookKeys.all(storeId), 'events'] as const,
  list: (storeId: string) => [...webhookKeys.all(storeId), 'list'] as const,
  details: (storeId: string) => [...webhookKeys.all(storeId), 'detail'] as const,
  detail: (storeId: string, id: string) => [...webhookKeys.details(storeId), id] as const,
  deliveries: (storeId: string, id: string) =>
    [...webhookKeys.detail(storeId, id), 'deliveries'] as const,
  deliveryList: (storeId: string, id: string, params: DeliveryListParams) =>
    [...webhookKeys.deliveries(storeId, id), params] as const,
};
